module.exports = __webpack_public_path__ + "img/chevron-down-small.45ac57af.svg";